module.exports = {"450981001":"陵城街道","450981002":"城南街道","450981003":"城北街道","450981100":"北流镇","450981101":"新荣镇","450981102":"民安镇","450981103":"山围镇","450981104":"民乐镇","450981105":"西垠镇","450981106":"新圩镇","450981107":"大里镇","450981108":"塘岸镇","450981109":"清水口镇","450981110":"隆盛镇","450981111":"大坡外镇","450981112":"六麻镇","450981113":"新丰镇","450981114":"沙垌镇","450981115":"平政镇","450981116":"白马镇","450981117":"大伦镇","450981118":"扶新镇","450981119":"六靖镇","450981120":"石窝镇","450981121":"清湾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450981.json
// module id = 1965
// module chunks = 0